import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ForgotPasswordParentComponent } from './containers/forgot-password-parent/forgot-password-parent.component';
import { ResetPasswordParentComponent } from './containers/reset-password-parent/reset-password-parent.component';
import { LoginParentComponent } from './containers/login-parent/login-parent.component';

export const authRoutes: Routes = [
	{
		path: 'login',
		component: LoginParentComponent
	},
	{
		path: 'forgot-password',
		component: ForgotPasswordParentComponent
	},
	{
		path: 'reset-password/:guidToken',
		component: ResetPasswordParentComponent
	}
];

@NgModule({
	imports: [RouterModule.forRoot(authRoutes)],
	exports: [RouterModule]
})
export class AuthRoutingModule {}
